module.exports = __webpack_public_path__ + "img/1-03.b92568f5.svg";